import { FormArray, FormControl, FormGroup } from "@angular/forms";

export function markAllAsTouched(form: FormGroup | FormArray): void {
  Object.values(form.controls).forEach((control) => {
    if (control instanceof FormControl) {
      control.markAsTouched();
      control.markAsDirty();
      control.updateValueAndValidity();
    } else if (control instanceof FormGroup || control instanceof FormArray) {
      markAllAsTouched(control); // Recursive call for subforms
    }
  });
}
